export default "__VITE_ASSET__7uo6GkGD__"